import {registerAPIService} from './APIServicesRegistry';
import APIServiceBase from './APIServiceBase';

export default class SparePartsFinderSOApiService extends APIServiceBase {
    constructor() {
        super('SPFSOIndex')
    }

    index(so, market) {
        return this.get(`GetIndexData?searchParameter=${so}&market=${market}`)
    }

    indexPage(data) {
        return this.post('IndexPage', data);
    }

    getPriceSummary(data) {
        return this.post('GetPriceSummary', data);
    }

    export(target, data) {
        return this.post('ExportFile?exporterType=' + target, data, 'blob')
    }
}

registerAPIService(SparePartsFinderSOApiService)